import AwardDetails from '@/awards/models/AwardDetails';

class CampaignAwards {
  awardShow = '';
  
  awards = [];

  constructor(campaignAwards) {
    if (campaignAwards != null) {
      this.awardShow = campaignAwards.awardShow;
      this.awards = AwardDetails.fromObjectList(campaignAwards.awards);
    }
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }
    return new CampaignAwards(data);
  }

  static fromObjectList(list) {
    if (list == null) {
      return null;
    }
    return list.map((data) => CampaignAwards.fromObject(data));
  }
}

export default CampaignAwards;
